import React from 'react';
import { DialogTitle } from '@mui/material';

const DSDialogTitle = (props: React.ComponentProps<typeof DialogTitle>) => {
  return <DialogTitle variant="h6" {...props} />;
};

export default DSDialogTitle;
